import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HideOnScrollService {
    // eslint-disable-next-line rxjs/no-exposed-subjects
    public hideOnDontListenSubject = new BehaviorSubject(false);

    public hideOnDontListen$ = this.hideOnDontListenSubject.asObservable();

    /**
     * notifica que la directiva no debe escuchar el scroll
     * @param DontListen {boolean}
     */
    public setDontListen(DontListen: boolean) {
        this.hideOnDontListenSubject.next(DontListen);
    }
}
